import { connect } from 'react-redux'
import showFileUploadModal from 'features/Files/FileUploadModal'

import UploadAudioForPortaComponent from './UploadAudioForPorta'

const stateToProps = () => ({})

const dispatchToProps = {
  showFileUploadModal,
}

export default connect(stateToProps, dispatchToProps)(UploadAudioForPortaComponent)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Porta/PortaSayPlay/UploadAudioForPorta.container.js